import React from 'react';

function ProductCard({ product, onClick, lang }) {
  return (
    <div className="product-card" onClick={() => onClick(product)}>
      <div className="product-image-container">
        <img
          src={product.images[0]}
          alt={product.name[lang]}
          className="product-image"
          loading="lazy"
        />
        <div className="product-badge">
          <span className="badge-power">{product.power}</span>
          <span className="badge-area">{product.area}</span>
        </div>
        <div className="product-overlay">
          <span className="overlay-text">
            {lang === 'it' ? 'Clicca per visualizzare la galleria' : 'Нажмите для просмотра галереи'}
          </span>
        </div>
      </div>

      <div className="product-info">
        <h3 className="product-name">{product.name[lang]}</h3>
        <p className="product-model">Модель: {product.model}</p>

        <div className="product-specs">
          <div className="spec-item">
            <span className="spec-label">
              {lang === 'it' ? 'Potenza:' : 'Мощность:'}
            </span>
            <span className="spec-value">{product.power}</span>
          </div>
          <div className="spec-item">
            <span className="spec-label">
              {lang === 'it' ? 'Area:' : 'Площадь:'}
            </span>
            <span className="spec-value">{product.area}</span>
          </div>
          <div className="spec-item">
            <span className="spec-label">
              {lang === 'it' ? 'Dimensioni:' : 'Размер:'}
            </span>
            <span className="spec-value">{product.size}</span>
          </div>
          <div className="spec-item">
            <span className="spec-label">
              {lang === 'it' ? 'Controllo:' : 'Управление:'}
            </span>
            <span className="spec-value">{product.wireless}</span>
          </div>
          <div className="spec-item">
            <span className="spec-label">
              {lang === 'it' ? 'Materiali:' : 'Материалы:'}
            </span>
            <span className="spec-value">{product.materials[lang]}</span>
          </div>
          <div className="spec-item">
            <span className="spec-label">
              {lang === 'it' ? 'Installazione:' : 'Установка:'}
            </span>
            <span className="spec-value">{product.installation[lang]}</span>
          </div>
        </div>

        <p className="product-description">{product.description[lang]}</p>

        <div className="product-footer">
          <span className="product-price">{product.price}</span>
          <button className="btn btn-primary btn-small">
            {lang === 'it' ? 'Ordina' : 'Заказать'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductCard;
